<template>
	<div id="index" ref="appRef">
		<div class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body" id="pushbtnbox">
				<Header @getTime="getTime"/>
				<div class="pushbtn">
					<el-button type="primary" v-if="!inpause" @click="pocBtn">暂停</el-button>
					<el-button type="primary" v-if="inpause" @click="pocBtn">继续</el-button>
				</div>
				<div class="sign_content">
					<div class="sign_content_top">
						<div class="sign_map">
							<citys />
						</div>
						<div class="signList">
							<div><rollListRight @toSignDetail="toSignDetail"/></div>
							<div class="sign_content_bottom">
								<product ref="products"/>
								<specialLogo ref="signList"/>
							</div>
						</div>
					</div>
					
				</div>
			</div>
			
			<!-- 详情弹框 -->
			<div class="dialog_bg" v-if="isShow">
				<div class="dialog_title">{{signDetail.NAME}}</div>
				<div class="close" @click="isShow = false">
					<i class="el-icon-close"></i>
				</div>
				<div class="dialog_sign_content">
					<img :src="signDetail.IMGURL" alt="">
					<div class="jieshao">
						{{signDetail.CONTENT}}
					</div>
				</div>
			</div>
		</div>
		<!--div class="pushbtn">
			<el-button type="primary" v-if="!inpause" @click="pocBtn">暂停</el-button>
			<el-button type="primary" v-if="inpause" @click="pocBtn">继续</el-button>
		</div-->
	</div>
</template>
<script>
	import "@/assets/scss/sign.scss";
	import "@/assets/scss/frame.scss";
	import drawMixin from "../utils/drawMixin";
	import Header from './header'
	import citys from './sign/map'
	// import rollListLeft from './sign/signList-left'
	import rollListRight from './sign/signList-right'
	//import product from './sign/product'
	import specialLogo from './sign/specialLogo'
	import {getPageThreeData} from '@/utils/api.js'
	export default {
		mixins: [drawMixin],
		data() {
			return {
				loading: true, //加载状态
				isShow:false,  //详情弹框
				signDetail:'',  //地理标志详情
				timer:'', //定时器
				inpause:false, // 是否继续
				detail:'',
			};
		},
		components: {
			Header,
			//rollListLeft,
			rollListRight,
			citys,
			//product,
			specialLogo,
		},
		mounted() {
			this.timer = setTimeout(() =>{
				if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
					this.$router.push('/five');
				}else{
					console.log(3,'已销毁')
				}
			},30000)
			this.cancelLoading();
			document.querySelector('body').setAttribute('style', 'background-color:#241843;')
		},
		beforeDestroy() {
			document.querySelector('body').setAttribute('style', 'background-color:#020308;')
		},
		methods: {
			// 获取年月
			getTime(val){
				var params = {
					year:val.year,
				}
				getPageThreeData(params).then(res=>{
					if(res.status == 200){
						console.log(res.data)
						//this.$refs.products.getData(res.data.dlbz);
						this.$refs.signList.getData(res.data);
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			// 列表详情
			toSignDetail(data){
				this.isShow = true
				this.signDetail = data
			},
			// 初始加载
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 500);
			},			
			pocBtn(){
				this.inpause = !this.inpause;
				console.log(this.inpause)
				if(this.inpause){
					console.log("cleartimeout")
					clearTimeout(this.timer);
				}else{
					this.timer = setTimeout(() =>{
						if(this && !this._isDestroyed){ //_isDestroyed 组件是否被销毁
							this.$router.push('/five');
						}else{
							console.log(2,'已销毁')
						}
					},30000)
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	
	.bg {
		background-image: url("../assets/one.jpg");
	}
</style>
